import styled from 'styled-components'
import { colors } from '../../../theme'
import Div100vh from 'react-div-100vh'
import { Link } from 'gatsby'

export const Wrapper = styled(Div100vh)`
  position: relative;
  background-image: linear-gradient(to left, ${colors.primary}, ${colors.secondary});
  overflow: hidden;
  max-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100vw;
  color: ${colors.primayFont};
  padding: 0 20px;
  z-index: 2;
  padding-left: 70px;
  @media screen and (max-width: 500px) {
    padding: 0 20px 70px 20px;
  }
`

export const Bursts = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100vw;
  z-index: 0;
`

export const Title = styled.div`
  position: absolute;
  top: 50px;
  width: 100%;
  text-align: center;
  font-size: 52px;
  font-family: 'Dancing script', cursive;
  font-weight: 500;
  > :nth-child(2) {
    font-weight: 400;
    margin-top: 10px;
    font-size: 20px;
  }
`

export const Headline = styled.div`
  margin-bottom: 20px;
`

export const BigNumber = styled.div`
  font-size: 34px;
  animation: animate-number 0.2s alternate linear infinite; 
  animation-delay: 3s;
  @keyframes animate-number {
    from {
      transform: rotate(-3deg);
    }
    to {
      transform: rotate(3deg);
    }
  }
`

export const Watch = styled.div`
  position: fixed;
  z-index: 100;
  color: white;
  bottom: 20px;
  left: 20px;
  font-size: 14px;
  font-family: 'Dancing script', cursive;
  text-decoration: underline;
  font-weight: 300;
`

export const Messages = styled.div`

`

export const Album = styled.div`

`

export const KohLantaButton = styled(Link)`
  cursor: pointer;
  position: fixed;
  bottom: 10px;
  left: 10px;
  > :first-child {
    height: 80px;
    width: 100px;
    background-image: url("${require('../../../../static/images/kohlanta.png')}");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }
`
